<script setup lang="ts">

</script>

<template>
    <div class="container mx-auto flex flex-col items-center gap-10 px-4 py-8 text-center footer-items text-primary font-light">
        <div>
            Wszystkie materiały są przeznaczone
            dla osób dorosłych powyżej 18 roku życia,
            nie należy ich przekazywać
            ani udostępniać osobom poniżej 18 lat.<br/>
            <span class="uppercase text-lg">Pij odpowiedzialnie.</span>
        </div>
        <a href="https://abcalkoholu.pl" target="_blank">
            <img src="@/assets/images/abcalkoholu.webp" width="80%" alt="Logo abcalkoholu" class="mx-auto max-w-[400px]">
        </a>
        <div>
            Jeśli uważasz, że treść naszego serwisu
            narusza zasady Kodeksu
            Etyki Reklamy, <a href="https://radareklamy.pl/" target="_blank" class="text-default-red underline">zgłoś&nbsp;to!</a>
            Dowiedz się więcej o alkoholu
            na <a href="https://abcalkoholu.pl" target="_blank" class="text-default-red underline">abcalkoholu.pl.</a>
        </div>
        <div>
            <div>2026 Wszelkie prawa zastrzeżone.</div>
            <router-link :to="{name: 'polityka'}" class="text-default-red underline">Polityka prywatności.</router-link>
        </div>
    </div>
</template>

<style scoped>
</style>